import type { FC } from "react";

export const TopographicCanvas: FC = () => {
  return (
    <div className="hr-topo-backdrop" aria-hidden="true">
      <svg
        className="hr-topo-svg"
        viewBox="0 0 1440 900"
        preserveAspectRatio="xMidYMid slice"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Inset 1px architectural perimeter datum frame matching 03-system-c.png */}
        <rect
          x="18"
          y="14"
          width="1404"
          height="872"
          stroke="currentColor"
          strokeWidth="1"
          opacity="0.58"
        />

        {/* Lower-left topographic elevation ridge system (matching 03-system-c.png bottom-left) */}
        <g stroke="currentColor" strokeWidth="1.1" opacity="0.72">
          <path d="M18 525 C 88 518, 134 542, 168 588 C 204 636, 258 634, 304 668 C 348 701, 366 762, 344 818 C 328 856, 336 874, 342 886" />
          <path d="M18 556 C 78 552, 118 574, 149 616 C 181 660, 232 658, 272 688 C 312 718, 326 772, 308 824 C 295 858, 301 875, 306 886" />
          <path d="M18 588 C 68 586, 102 604, 130 642 C 158 682, 204 680, 240 708 C 276 735, 288 781, 272 828 C 261 860, 266 876, 270 886" />
          <path d="M18 620 C 58 619, 86 634, 111 668 C 135 702, 176 702, 208 727 C 240 752, 250 790, 236 832 C 227 861, 231 876, 235 886" />
          <path d="M18 654 C 48 653, 71 666, 92 695 C 112 724, 148 725, 176 746 C 204 768, 212 800, 200 836 C 193 862, 196 877, 199 886" />
          <path d="M18 688 C 39 688, 56 699, 73 722 C 90 746, 120 748, 144 766 C 168 784, 174 810, 164 841 C 158 863, 161 877, 163 886" />
          <path d="M44 786 C 44 756, 72 742, 98 758 C 124 774, 132 808, 118 836 C 104 862, 68 866, 50 842 C 39 826, 44 804, 44 786 Z" />
          <path d="M62 794 C 62 775, 79 766, 95 776 C 110 786, 114 808, 105 825 C 96 841, 75 843, 65 829 C 59 819, 62 806, 62 794 Z" />
        </g>

        {/* Upper-right topographic summit & saddle contours (matching 03-system-c.png top-right) */}
        <g stroke="currentColor" strokeWidth="1.1" opacity="0.72">
          <path d="M1032 14 C 1022 58, 1034 108, 1068 144 C 1102 180, 1110 232, 1094 282 C 1078 332, 1094 388, 1138 424 C 1182 460, 1242 468, 1296 446 C 1348 425, 1384 434, 1422 458" />
          <path d="M1066 14 C 1058 52, 1068 96, 1098 128 C 1128 160, 1136 206, 1122 252 C 1108 298, 1122 348, 1162 380 C 1202 412, 1254 420, 1302 400 C 1348 381, 1386 390, 1422 412" />
          <path d="M1102 14 C 1096 46, 1104 84, 1130 112 C 1156 140, 1162 182, 1150 222 C 1138 262, 1150 308, 1186 336 C 1222 364, 1266 372, 1308 354 C 1348 337, 1388 345, 1422 366" />
          <path d="M1138 14 C 1134 40, 1140 72, 1162 96 C 1184 120, 1190 156, 1180 192 C 1170 228, 1180 268, 1210 292 C 1240 316, 1278 322, 1314 308 C 1349 294, 1389 301, 1422 320" />
          <path d="M1214 142 C 1214 96, 1252 68, 1296 76 C 1340 84, 1372 128, 1364 178 C 1356 228, 1316 262, 1272 254 C 1228 246, 1214 188, 1214 142 Z" />
          <path d="M1238 146 C 1238 112, 1266 90, 1298 96 C 1330 102, 1352 135, 1346 172 C 1340 209, 1312 234, 1280 228 C 1248 222, 1238 180, 1238 146 Z" />
          <path d="M1262 150 C 1262 128, 1280 114, 1300 118 C 1320 122, 1334 143, 1330 166 C 1326 189, 1308 205, 1288 201 C 1268 197, 1262 172, 1262 150 Z" />
        </g>

        {/* Subtle mid-canvas datum & secondary elevation sweeps */}
        <g stroke="currentColor" strokeWidth="0.85" opacity="0.36">
          <path d="M410 14 C 428 74, 476 112, 542 118 C 608 124, 668 92, 718 14" />
          <path d="M448 14 C 464 56, 500 84, 548 88 C 596 92, 640 68, 678 14" />
          <path d="M680 886 C 712 818, 784 786, 862 798 C 940 810, 994 848, 1024 886" />
          <path d="M724 886 C 750 838, 802 816, 858 824 C 914 832, 956 858, 978 886" />
        </g>
      </svg>
    </div>
  );
};
